import baseMigrate from "@Shared/Entities/AbstractEntities/BaseEntity/migrate";
const version1 = (current = {}) => {
    const { version = 0 } = current;
    if (version >= 1) {
        return current;
    }
    return { ...current, version: 1 };
};
export const migrate = (original = {}) => {
    const baseMigrated = baseMigrate(original);
    const converted = [version1].reduce((converted, f) => f(converted), original);
    const { networkId, name, type } = converted;
    let { selectedCountries } = converted;
    if (selectedCountries !== undefined &&
        typeof selectedCountries === "string") {
        selectedCountries = JSON.parse(selectedCountries);
    }
    return {
        ...baseMigrated,
        networkId,
        name,
        selectedCountries,
        type,
    };
};
